export default __webpack_public_path__ + "static/media/ENFP.e21d575d.svg";